import { Typography } from "@mui/material";
import DocumentEditor from "components/editor/DocumentEditor";

// Define the base props that all picture types should have
interface BasePictureProps {
  pictureName: string;
}

export interface DocumentPictureProps extends BasePictureProps {
  pictureName: "document";
  setContent: (content: any) => void;
  passiveEditor: boolean;
  placeholder: string;
  initialContent: any;
  attachmentsEnabled: boolean;
  initialAttachments: any[];
  editorDefaultFontSize: string;
  placement: "top" | "bottom";
  scrollable: boolean;
  ref: React.RefObject<any>;
  linkUnfurlEnabled: boolean;
  autoSaveStatus: any;
  editorMinHeight: string;
  editorMaxHeight: string;
  documentTitle: string;
}

export const DocumentPicture = (props: DocumentPictureProps) => {
  const { documentTitle, ...editorProps } = props;

  return (
    <>
      <Typography variant="h6">{documentTitle}</Typography>
      <DocumentEditor
        {...editorProps}
        imageOptions={{
          showDownload: false,
          showZoom: false,
          showModal: false,
        }}
      />
    </>
  );
};

// Export the base type for other components to use
export type { BasePictureProps };
